import { useEffect, useState } from "react";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

// Estilos
import "./SearchInput.css";

/* 
    Componente de boton flotante de lupa que funciona para filtrar por busqueda.
        Donde buscar es la función que llama para filtrar por lo ingresado por el usuario.
*/
function SearchInput({ defaultValue, buscar, debounceMs = 250 }) {
  const [expanded, setExpanded] = useState(false);
  const [inputValue, setInputValue] = useState(defaultValue ?? "");

  useEffect(() => {
    const timer = setTimeout(() => buscar(inputValue), debounceMs);
    return () => clearTimeout(timer);
  }, [inputValue, debounceMs]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleBlur = () => {
    if (inputValue.trim() === "") {
      setExpanded(false);
    }
  };

  const handleFocus = () => {
    setExpanded(true);
  };

  return (
    <div
      className={`search-container add-search ${expanded ? "expanded" : ""}`}
      onFocus={handleFocus}
    >
      <FontAwesomeIcon icon={faMagnifyingGlass} className="add-search-cont" />
      <input
        placeholder="Buscar..."
        className="input-search-txt"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  );
}

export default SearchInput;